import { render } from "./InstructionOneBoxPage.vue?vue&type=template&id=011fd1b0&scoped=true"
import script from "./InstructionOneBoxPage.vue?vue&type=script&lang=js"
export * from "./InstructionOneBoxPage.vue?vue&type=script&lang=js"

import "./InstructionOneBoxPage.vue?vue&type=style&index=0&id=011fd1b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-011fd1b0"]])

export default __exports__